import "@/styles/components/glow-point.css";

export default {
  init: () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        e.target.style.animationPlayState = e.isIntersecting ? "running" : "paused";
      });
    });

    document.querySelectorAll('[data-glow-point="observe"]').forEach((el) => {
      el.style.animationPlayState = "paused";
      observer.observe(el);
    });
  },
};
